import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltung-info-kategorien2';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungInfoKategorien2Effects {

    VeranstaltungInfoKategorien2$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_INFO_KATEGORIEN2),
        mergeMap((x: ac.GetVeranstaltungInfoKategorien2Action) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungInfoKategorien2(x.veranstaltung_id).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungInfoKategorien2ErfolgreichAction(result, x.veranstaltung_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungInfoKategorien2FehlerAction(error, x.veranstaltung_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.InfoKategorienQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.InfoKategorienQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.InfoKategorienQueryService);
        }
        return this.service;
    }
}
